import * as yup from 'yup';

export const editValidationSchema = yup.object({
  email: yup.string().required('Required').email(),
  phoneNumbers: yup.array().of(
    yup.object({
      phoneNumber: yup
        .string()
        .required('Required')
        .matches(/^\+[1-9]\d{6,14}$/i, {
          message: 'Invalid phone number',
        }),
    })
  ),
});

export const createValidationSchema = yup.object({
  firstName: yup.string().required('Required'),
  lastName: yup.string().required('Required'),
  email: yup.string().required('Required').email(),
  password: yup.string().required('Required'),
  phoneNumbers: yup.array().of(
    yup.object({
      phoneNumber: yup
        .string()
        .required('Required')
        .matches(/^\+[1-9]\d{6,14}$/i, {
          message: 'Invalid phone number',
        }),
    })
  ),
});
